<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="loading"></loading-placeholder>
        <el-table :data="data" stripe border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="name" label="赛事名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="year_text" label="赛事年份" align="center" min-width="70"></el-table-column>
            <el-table-column prop="theme" label="赛事主题" align="center" min-width="100"></el-table-column>
            <el-table-column prop="venue_full_name" label="举办地址" align="center" min-width="120"></el-table-column>
            <el-table-column prop="registration_deadline_text" label="报名截止时间" align="center"
                             width="100"></el-table-column>
            <el-table-column prop="start_time_text" label="比赛开始时间" align="center"
                             width="100"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" plain
                               :disabled="scope.row.registered === true || scope.row.application_unfinished === true"
                               @click="apply(scope.row)"
                    >
                        {{ scope.row.registered === true ? '已参赛' :
                        scope.row.application_unfinished === true ? '申请处理中' : '申请参赛' }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <popup :visible.sync="visible" :competition="competition" @need-reload="afterRegistration"></popup>
    </div>
</template>

<script>
    import Popup from './popup';

    export default {
        name: '',
        components: {
            Popup
        },
        props: {
            data: {
                type: Array,
                default: () => []
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                visible: false,
                competition: null
            };
        },
        methods: {
            apply (competition) {
                this.visible = true;
                this.competition = competition;
            },
            afterRegistration () {
                this.$emit('need-reload');
            }
        }
    };
</script>
